<div class="section-container" *ngIf="office && office.agency">
  <div class="flex align-items-start justify-content-between">
    <h3>Agency Types</h3>
    <button
      *ngIf="hasRole('db-edit-offices')"
      pButton
      label="Edit Types"
      type="button"
      (click)="updateClicked()"
      class="p-button-raised p-button-warning"
      icon="pi pi-save"
      style="margin-bottom: 10px"
    ></button>
  </div>

  <p-chip *ngFor="let agencyType of office.agency.types">
    {{ agencyType.name }}
  </p-chip>
  <h4 *ngIf="!office.agency.types || office.agency.types.length === 0">No types assigned</h4>
</div>
